

interface SurveyHealthBadgeProps {
  status: 'HEALTHY' | 'WARNING' | 'CRITICAL';
  brokenCount?: number;
  className?: string;
}

export function SurveyHealthBadge({ status, brokenCount, className = '' }: SurveyHealthBadgeProps) {
  const config = {
    HEALTHY: {
      color: 'bg-green-100 text-green-800 border-green-200',
      icon: '✓',
      label: 'Healthy',
    },
    WARNING: {
      color: 'bg-yellow-100 text-yellow-800 border-yellow-200',
      icon: '⚠',
      label: 'Warning',
    },
    CRITICAL: {
      color: 'bg-red-100 text-red-800 border-red-200',
      icon: '✕',
      label: 'Critical',
    },
  };

  const { color, icon, label } = config[status];

  return (
    <span
      className={`inline-flex items-center gap-1 px-2.5 py-0.5 rounded-full text-xs font-medium border ${color} ${className}`}
      title={brokenCount ? `${brokenCount} broken reference(s)` : undefined}
    >
      <span>{icon}</span>
      <span>{label}</span>
      {brokenCount && brokenCount > 0 ? (
        <span className="ml-1 font-semibold">({brokenCount})</span>
      ) : null}
    </span>
  );
}

interface SurveyHealthIndicatorProps {
  status: 'HEALTHY' | 'WARNING' | 'CRITICAL';
  brokenCount?: number;
  showMessage?: boolean;
}

export function SurveyHealthIndicator({
  status,
  brokenCount = 0,
  showMessage = true,
}: SurveyHealthIndicatorProps) {
  const messages = {
    HEALTHY: 'All PEO/PO references are valid',
    WARNING: `${brokenCount} broken reference(s). Fix before deploying.`,
    CRITICAL: `${brokenCount} broken reference(s) in deployed survey!`,
  };

  return (
    <div className="flex items-center gap-2">
      <SurveyHealthBadge status={status} brokenCount={brokenCount} />
      {showMessage && (
        <span className="text-sm text-gray-600">{messages[status]}</span>
      )}
    </div>
  );
}
